module.exports = __webpack_public_path__ + "img/scan.73eb7d46.svg";